import React from 'react'

import EarthMarker from '../EarthMarker'

import earth from './assets/earth_first.png'

const EarthMobile = () => {
  return (
    <>
      <img src={earth} alt="earth" />
      <EarthMarker isVisible={true} />
    </>
  )
}

export default EarthMobile
